import styled from "styled-components"

import Icon from "icons"

export const PromotionIcon = styled(Icon)`
  margin-left: 1rem;
`
